module.exports = {XMLHttpRequest:XMLHttpRequest};


//////////////////
// WEBPACK FOOTER
// external "{XMLHttpRequest:XMLHttpRequest}"
// module id = 735
// module chunks = 2